import React from 'react';

import download from 'assets/download.svg';
import print from 'assets/print.png';
import PropTypes from 'prop-types';
import { getVoucherUrl, getVoucherPrintUrl } from 'utils/media';

import { VoucherContainer, VoucherButtons } from './styles';

export default function Voucher({ registrationId, program }) {
  const voucherUrl = getVoucherUrl(registrationId, 'png');

  return (
    <>
      {/* <VoucherContainer>
      <img
        alt="Voucher"
        src={voucherUrl}
      />
    </VoucherContainer>

    <VoucherButtons>
      <a href={voucherUrl} download="voucher.png" target="_blank" rel="noopener noreferrer">
        <img src={download} alt="Salvar Voucher" />
        <span>SALVAR VOUCHER</span>
      </a>

      <a href={getVoucherPrintUrl(registrationId, 'png')} target="_blank" rel="noopener noreferrer">
        <img src={print} alt="Imprimir" />
        <span>IMPRIMIR</span>
      </a>
    </VoucherButtons>*/}
    </>
  );
}

Voucher.propTypes = {
  registrationId: PropTypes.string.isRequired,
  program: PropTypes.string.isRequired,
};
